import { isDirty, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import ExternalInternalForm from '../../../../itrust_common/components/authorised/examFormPartial/ExternalInternalForm';
import { dateTimeFormat } from '../../../../itrust_common/components/HelperFunctions';
import { useEffect } from 'react';

function ExamExternalInternalForm(props) {
  const { handleSubmit, template, exam } = props;

  useEffect(() => {
    return () => {
      if (props.dirty) {
        handleSubmit();
      }
    }
  }, [props.dirty])

  return (
    <form onSubmit={handleSubmit}>
      <ExternalInternalForm pprops={props} exam={exam} template={template} isTemplate={false} />
    </form>
  )
}

ExamExternalInternalForm = reduxForm({
  form: 'examExternalInternalForm',
  enableReinitialize: true
})(ExamExternalInternalForm)

const mapStateToProps = state => {
  const { exam: { exam } } = state
  return {
    exam: exam,
    initialValues: {
      id: exam.id,
      external_attributes: exam.external_attributes,
      internal_attributes: {
        ...exam.internal_attributes,
        instilled_at: exam.internal_attributes?.instilled_at && dateTimeFormat(exam.internal_attributes?.instilled_at)
      },
      gat: exam.gat,
      nct: exam.nct,
      visual_field: exam.visual_field
    }
  }
}

export default connect(mapStateToProps)(ExamExternalInternalForm)